import { api } from 'src/api/axios';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface AuthResponse {
  accessToken?: string;
  token?: string;
  user?: unknown;
}

export interface MeResponse {
  id: unknown;
  createdAt: string;
  updatedAt: string;
  firstName: string;
  lastName: string;
  midName: string;
  email: string;
  phone: string;
  role: number;
}

export const authService = {
  login: async (data: LoginRequest): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/login', data);
    return response.data;
  },
  me: async (): Promise<MeResponse> => {
    const response = await api.get('/auth/me');
    return response.data;
  }
};